import SearchInputComponent from './SearchInput.component';

export * from './SearchInput.component';
export default SearchInputComponent;
